<!-- -->
<template>
  <el-form-item  :label="label" :prop="prop" :required="rules?true:false" :rules="rule">
    <slot></slot>
  </el-form-item>
</template>

<script>
  export default {
    props:{
      label:String,
      prop:[String,Array],
      type:String,
      rules:{
        type:Object,
      }
    },
    name: "form-item-rule",
    data() {
      return {
        rule:[],
      }
    },
    mixins: [tableBase],
    methods: {},
    mounted() {
      if(this.rules){
        this.rule =  this.rules;
      }else if(this.type){
        if(this.type==='mobile'){
          this.rule = [{required: true, message: this.label+'不能为空', trigger: 'blur'},
            {pattern: mobilePass, message: '请输入正确的手机号码', trigger: 'blur' }];
        }else if(type==='email'){
          this.rule = [{required: true, message: this.label+'不能为空', trigger: 'blur'},
            {pattern: emailPass, message: '请输入正确的邮箱', trigger: 'blur' }];
        }else{
          console.error("type is error");
        }
      }else{
        this.rule = [{required: true, message: this.label+'不能为空', trigger: 'blur'}];
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
